<template>
  <div class="w-100 pl-5 pt-5 mh-100 h-100">
    <Toast />
    <div class="d-flex w-100 p-0 mh-100 h-100">
      <i
        style="position: absolute; left: 20px; z-index: 1; top: 85px"
        class="fa-solid fa-chevron-right cursor-pointer"
        @click="toggleMenu"
        v-if="!toggleMenuLeft"
      ></i>
      <div
        class="p-0 d-flex flex-column justify-content-between py-5 px-3 h-100"
        style="
          border-right: 1px solid #e9ecef;
          transition: all 0.3s ease-in-out;
          min-width: 300px;
        "
        v-if="toggleMenuLeft"
      >
        <div class="w-100 h-100 d-flex flex-column justify-content-between">
          <div>
            <div class="w-100 d-flex justify-content-end">
              <i
                @click="toggleMenu"
                class="fa-solid fa-chevron-left cursor-pointer"
              ></i>
            </div>
            <div>
              <div class="d-flex flex-column">
                <label for="">Conta</label>
                <Dropdown
                  v-model="contaSelecionada"
                  :options="contas"
                  optionLabel="label"
                  optionValue="id"
                  placeholder="Sistema"
                  appendTo="body"
                  style="width: 280px"
                  @change="onContaChange"
                  filter
                />
              </div>
              <div class="d-flex flex-column mt-3" id="sistema-licenciada">
                <label for="">Sistema licenciada</label>
                <Dropdown
                  v-model="sistemaLicenciadaSelecionado"
                  :options="sistemaLicenciada"
                  optionLabel="sli_titulo"
                  optionValue="sistema_licenciada_id"
                  placeholder="Sistema"
                  appendTo="body"
                  style="width: 280px"
                  @change="onLicenciadaChange"
                  filter
                />
              </div>
              <div class="d-flex flex-column mt-3" id="modelo">
                <label for="">Modelo</label>
                <Dropdown
                  v-model="modeloSelecionado"
                  :options="modelos"
                  optionLabel="md_descricao"
                  optionValue="modelo_id"
                  placeholder="Modelo"
                  style="width: 280px"
                  @change="onModeloChange"
                  appendTo="body"
                  filter
                />
              </div>
            </div>
            <div class="mt-3">
              <!-- <Tree :value="treeData"></Tree> -->
              <v-treeview
                v-if="this.sistemaLicenciadaItem.bat_sql_bancos"
                :items="treeData"
                activatable
                dense
                item-key="name"
                :load-children="carregarConfigDB"
                open-on-click
                transition
                style="height: 350px; width: 100%; overflow-x: auto"
              >
                <template v-slot:prepend="{ item }">
                  <v-icon>
                    {{ item.icon }}
                  </v-icon>
                </template>
                <template v-slot:label="{ item }">
                  <span
                    class="font-weight-bold d-flex align-items-center"
                    :title="item.name"
                    @contextmenu.prevent="copiarNomeTabela($event, item.name)"
                  >
                    {{ item.name }}
                    <i
                      v-if="
                        item.data &&
                        item.data.item &&
                        item.data.item.tipo &&
                        item.data.item.sql_da_estrutura &&
                        item.data.item.tipo == 'VIEW'
                      "
                      class="fa-solid fa-eye ml-2"
                      @click="
                        exibirSqlView($event, item.data.item.sql_da_estrutura)
                      "
                      title="Copiar SQL de criação da VIEW"
                    ></i
                  ></span>
                </template>
              </v-treeview>
              <button
                v-if="nodePendente"
                class="btn btn-warning btn-sm mt-3"
                @click="carregarConfigDB(nodePendente)"
              >
                <i
                  v-if="loadingTree"
                  class="fa-solid fa-spinner fa-spin mr-2"
                ></i>
                Buscar resposta
              </button>
            </div>
          </div>

          <div>
            <div class="mt-15" v-if="historicoFiltrado.length">
              <div
                v-b-toggle.collapse-1
                @click="historicoAberto = !historicoAberto"
                class="d-flex align-items-center"
              >
                <i
                  class="fa-solid mr-3"
                  :class="{
                    'fa-caret-right': !historicoAberto,
                    'fa-caret-down': historicoAberto
                  }"
                ></i
                >Histórico local
              </div>
              <b-collapse id="collapse-1" class="mt-2">
                <div style="max-height: 200px; overflow-y: auto">
                  <div
                    v-for="item in historicoFiltrado"
                    :key="item.sql"
                    class="sql-item cursor-pointer ml-6"
                    :title="item.sql"
                    @click="$refs.monacoEditor.setQuery(item.sql)"
                  >
                    {{ item.sql }}
                  </div>
                </div>
              </b-collapse>
            </div>
            <label for="" class="mr-3">Limite</label>
            <Dropdown
              v-model="limit"
              :options="[
                { label: 'Sem limite', value: -1 },
                { label: '10 linhas', value: 10 },
                { label: '30 linhas', value: 30 },
                { label: '50 linhas', value: 50 },
                { label: '100 linhas', value: 100 },
                { label: '500 linhas', value: 500 },
                { label: '1000 linhas', value: 1000 }
              ]"
              optionLabel="label"
              optionValue="value"
              placeholder="Limite de linhas"
              appendTo="body"
            />
          </div>
        </div>
      </div>
      <div
        id="container-editor"
        class="p-0 d-flex flex-column justify-content-between pt-5"
        style="max-height: 100vh; flex: 1; min-width: 0"
      >
        <div class="d-flex justify-content-end w-100">
          <!-- style="position: absolute; left: 5px; z-index: 1; top: 0px" -->
          <i
            class="fa-solid cursor-pointer mr-8"
            :class="{
              'fa-chevron-up': toggleEditor,
              'fa-chevron-down': !toggleEditor
            }"
            @click="onToggleEditor"
          ></i>
        </div>
        <MonacoEditor
          v-show="enabledQuery && toggleEditor"
          ref="monacoEditor"
          class="w-100 mh-100"
          @sql="updateSql"
        />
        <div v-if="!enabledQuery" class="w-100" style="min-height: 300px">
          <p class="text-center">Selecione uma conta e um banco de dados</p>
        </div>
        <div>
          <div class="d-flex mb-3 ml-3 pr-3 w-100 justify-content-between">
            <button
              class="btn btn-success btn-sm"
              :class="{
                'spinner spinner-left spinner-white pl-15':
                  queryLoading || queryLoadingResposta
              }"
              :disabled="queryLoading || queryLoadingResposta || !enabledButton"
              @click="executarQuery"
            >
              <i
                class="flaticon2-arrow"
                v-if="!queryLoading && !queryLoadingResposta"
              ></i>
              Executar Query
            </button>
            <button
              v-if="lastHashRequestFailed"
              class="btn btn-warning btn-sm mr-3"
              :title="lastHashRequestFailed"
              @click="
                () => {
                  respostaQuery(lastHashRequestFailed);
                  lastHashRequestFailed = '';
                }
              "
            >
              Buscar resposta
            </button>
          </div>
          <div style="border-top: 1px solid #e9ecef">
            <Message
              :life="60000"
              severity="error"
              v-if="error"
              :sticky="false"
              @close="error = null"
              >{{ error }}</Message
            >
            <DataTable
              :value="linhas"
              showGridlines
              responsiveLayout="scroll"
              :resizableColumns="true"
              ref="dt"
              columnResizeMode="expand"
              :scrollHeight="toggleEditor ? '400px' : '75vh'"
              :scrollable="true"
              filterDisplay="menu"
              stripedRows
              class="p-datatable-sm w-100"
              :class="{ 'pui-datatable': colunas.length }"
              autoLayout
              :filters.sync="filters1"
              :globalFilterFields="globalFilterFields"
              :loading="queryLoading || queryLoadingResposta"
            >
              <template #header>
                <div class="d-flex justify-content-between">
                  <Button
                    icon="pi pi-external-link"
                    label="Exportar"
                    class="p-button-outlined"
                    @click="$refs.dt.exportCSV()"
                  />
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-filter-slash"
                      label="Limpar"
                      class="p-button-outlined mr-3"
                      @click="clearFilter1"
                    />
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText
                        v-model="filters1['global'].value"
                        placeholder="Pesquisar..."
                      />
                    </span>
                  </div>
                </div>
              </template>

              <template #empty>Sem dados para exibir.</template>
              <template #loading
                >Carregando dados. Por favor, aguarde.</template
              >

              <Column
                v-if="colunas.length"
                header=" "
                frozen
                :bodyStyle="{ 'text-align': 'center' }"
                :headerStyle="{ 'text-align': 'center' }"
              >
                <template #body="slotProps">
                  <div class="d-flex justify-content-center w-100">
                    {{ slotProps.index + 1 }}
                  </div>
                </template>
              </Column>

              <Column
                v-for="col in colunas"
                :key="col.field"
                :field="col.field"
                sortable
                :filterField="col.field"
              >
                <template #header>
                  <div
                    @contextmenu.prevent="copyColumnName(col.header)"
                    class="cursor-pointer"
                    title="Copiar nome da coluna"
                  >
                    {{ col.header }}
                  </div>
                </template>
                <template v-slot:filter="{ filterModel }">
                  <InputText
                    type="text"
                    v-model="filterModel.value"
                    class="p-column-filter"
                    :placeholder="'Filtrar por ' + col.header"
                  />
                </template>
                <!-- <template #body="slotProps">
                  <div
                    style="white-space: pre-wrap"
                    @click="
                      copiarTexto(event, slotProps.data[slotProps.column.field])
                    "
                  >
                    {{ slotProps.data[slotProps.column.field] }}
                  </div>
                </template> -->
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonacoEditor from "./MonacoEditor.vue";
import Dropdown from "primevue/dropdown";
import DataTable from "primevue/datatable";
import Tree from "primevue/tree";
import Column from "primevue/column";
import { FilterMatchMode, FilterOperator } from "primevue/api/";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import sqlRunnerService from "@/core/services/sql-runner.service.js";
import Message from "primevue/message";
import { mapGetters } from "vuex";
import Toast from "primevue/toast";

export default {
  name: "SQLRunner",
  components: {
    MonacoEditor,
    Dropdown,
    DataTable,
    Column,
    InputText,
    Button,
    Message,
    Toast
  },
  data() {
    return {
      sql: "",
      contas: [],
      contaSelecionada: null,
      sistemaLicenciada: [],
      sistemaLicenciadaSelecionado: null,
      modelos: [],
      modeloSelecionado: null,
      queryLoading: false,
      queryLoadingResposta: false,
      linhas: [],
      colunas: [],
      filters1: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      },
      globalFilterFields: [],
      error: null,
      log: "",
      historico: [],
      historicoAberto: false,
      toggleMenuLeft: true,
      toggleEditor: true,
      limit: 50, // Limite padrão de linhas
      lastHashRequestFailed: "",
      treeData: [
        {
          name: "Carregar configurações...",
          children: [],
          type: "start"
        }
      ],
      nodePendente: null,
      loadingTree: false
    };
  },
  mounted() {
    this.contas = this.contasParaTroca.map((conta) => ({
      ...conta,
      label: `${conta.id} - ${conta.login} ${
        conta.nome ? "(" + conta.nome + ")" : ""
      }`
    }));
    this.contas.push({
      id: this.currentUserPersonalInfo.conta_id,
      label:
        this.currentUserPersonalInfo.conta_id +
        " - " +
        this.currentUserPersonalInfo.conta
    });
    const historicoLocal = localStorage.getItem("sqlRunnerHistorico");
    if (historicoLocal) {
      try {
        this.historico = JSON.parse(historicoLocal);
      } catch (e) {
        console.error("Erro ao carregar histórico do localStorage", e);
      }
    }

    if (this.currentUserPersonalInfo.conta_id) {
      this.contaSelecionada = this.currentUserPersonalInfo.conta_id;
      this.onContaChange();
    }

    window.addEventListener("keydown", (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "r") {
        e.preventDefault();
        this.executarQuery();
      }
    });
  },
  computed: {
    ...mapGetters(["contasParaTroca", "currentUserPersonalInfo"]),
    historicoFiltrado() {
      return this.historico.filter(
        (i) =>
          i.conta === this.contaSelecionada &&
          i.sistemaLicenciada === this.sistemaLicenciadaSelecionado
      );
    },
    enabledQuery() {
      return this.sistemaLicenciada.some((i) => {
        return (
          i.sistema_licenciada_id === this.sistemaLicenciadaSelecionado &&
          !["API_E", "API_G", "WHK"].includes(i.banco_id)
        );
      });
    },
    enabledButton() {
      return (
        this.contaSelecionada &&
        this.sistemaLicenciadaSelecionado &&
        this.enabledQuery
      );
    },
    sistemaLicenciadaItem() {
      const q = this.sistemaLicenciada?.find(
        (i) => i.sistema_licenciada_id === this.sistemaLicenciadaSelecionado
      );
      return q ?? {};
    }
  },
  methods: {
    exibirSqlView(event, sql) {
      event.stopPropagation();
      // this.$refs.monacoEditor.setQuery(sql);
      this.copiarAreaTransferencia(sql);
    },
    copiarNomeTabela(event, coluna) {
      event.stopPropagation();
      this.copiarAreaTransferencia(coluna);
    },
    copiarAreaTransferencia(texto) {
      navigator.clipboard
        .writeText(texto)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Copiado para área de transferência",
            life: 3000
          });
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao copiar para área de transferência",
            life: 3000
          });
        });
    },
    handleChange(val, event) {
      this.$emit("update:value", val);
    },
    onContaChange() {
      if (!this.contaSelecionada) return;
      this.resetTreeData();
      sqlRunnerService
        .getLicenciadasPorConta(this.contaSelecionada)
        .then((response) => {
          this.sistemaLicenciada = response.data;
        });
    },
    onLicenciadaChange() {
      if (!this.sistemaLicenciadaSelecionado) return;
      this.resetTreeData();
      sqlRunnerService
        .getModeloPorSisLicenciada(this.sistemaLicenciadaSelecionado)
        .then((response) => {
          this.modelos = response.data;
        });
    },
    onModeloChange() {
      if (!this.modeloSelecionado) return;
      const modelo = this.modelos.find(
        (modelo) => modelo.modelo_id === this.modeloSelecionado
      );
      this.sql = modelo ? modelo.md_consulta : "";
      this.$refs.monacoEditor.setQuery(this.sql);
    },
    executarQuery() {
      if (!this.sql) {
        return;
      }
      this.lastHashRequestFailed = "";
      const bancoId = this.sistemaLicenciada.find(
        (i) => i.sistema_licenciada_id === this.sistemaLicenciadaSelecionado
      ).banco_id;
      const queryFormatada = this.formatarConsultaPorBanco(this.sql, bancoId);

      this.queryLoading = true;
      this.linhas = [];
      this.colunas = [];
      this.logger("Solicitando a execução da query...");
      sqlRunnerService
        .execQuery(this.sistemaLicenciadaSelecionado, queryFormatada, {
          showOverlay: false
        })
        .then((response) => {
          this.logger("Query executada com sucesso. Aguardando resposta...");
          if (!response.data.sucesso) {
            this.error = response.data.error;
            return;
          }
          this.salvarHistorico();
          this.respostaQuery(response.data.uid);
        })
        .catch((error) => {
          this.error = error.response
            ? error.response.data.requisicao.requisicao.resultado
            : "Erro ao executar a query.";
        })
        .finally(() => {
          this.queryLoading = false;
        });
    },
    respostaQuery(uid) {
      this.queryLoadingResposta = true;
      sqlRunnerService
        .respostaQuery(this.sistemaLicenciadaSelecionado, uid, {
          showOverlay: false
        })
        .then((response) => {
          if (!response.data.requisicao.sucesso) {
            this.error = response.data.requisicao.error;
            return;
          }
          if (response.data.requisicao.requisicao.status == "PENDENTE") {
            this.lastHashRequestFailed = uid;
            this.error =
              "A consulta ainda está sendo processada. Por favor, aguarde alguns instantes e tente novamente.";
            return;
          }
          if (response.data.requisicao.requisicao.sucesso_requisicao) {
            this.linhas = response.data.requisicao.requisicao.resultado;
            this.formatarDadosTabela();
          } else {
            this.error = response.data.requisicao.requisicao.resultado;
          }
        })
        .finally(() => {
          this.queryLoadingResposta = false;
        });
    },
    updateSql(val) {
      this.sql = val;
    },
    formatarDadosTabela() {
      this.colunas = Object.keys(this.linhas[0] || {}).map((key) => ({
        field: key,
        header: key,
        sortable: true
      }));

      if (this.colunas.some((c) => c == "")) {
        this.error =
          "A consulta retornou colunas sem nome. Verifique a consulta SQL.";
      }

      this.filters1 = {
        global: { value: null, matchMode: "contains" }
      };

      this.colunas.forEach((col) => {
        this.filters1[col.field] = {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        };
      });

      this.linhas.forEach((obj) => {
        Object.keys(obj).forEach((chave) => {
          if (obj[chave] === null || obj[chave] === undefined) {
            obj[chave] = "[NULL]";
          }
        });
      });

      this.globalFilterFields = this.colunas.map((col) => col.field);
    },
    clearFilter1() {
      Object.keys(this.filters1).forEach((key) => {
        this.filters1[key].value = null;
      });
    },
    logger(message, life = -1) {
      this.log = message;
      if (life > 0) {
        setTimeout(() => {
          this.log = "";
        }, life);
      }
    },
    salvarHistorico() {
      if (
        this.historico.some(
          (item) =>
            item.sql === this.sql &&
            item.conta === this.contaSelecionada &&
            item.sistemaLicenciada === this.sistemaLicenciadaSelecionado
        )
      ) {
        return;
      }
      this.historico.unshift({
        sql: this.sql,
        data: new Date(),
        conta: this.contaSelecionada,
        sistemaLicenciada: this.sistemaLicenciadaSelecionado,
        modelo: this.modeloSelecionado
      });
      this.historico = this.historico.slice(0, 50);
      localStorage.setItem(
        "sqlRunnerHistorico",
        JSON.stringify(this.historico)
      );
    },
    toggleMenu() {
      this.toggleMenuLeft = !this.toggleMenuLeft;
    },
    onToggleEditor() {
      this.toggleEditor = !this.toggleEditor;
    },
    formatarConsultaPorBanco(consulta, bancoId) {
      consulta = consulta.trim().replace(/;$/, ""); // remove ; final

      // Aplica apenas se começar com SELECT
      if (!/^select\s/i.test(consulta)) {
        return consulta;
      }

      if (this.limit < 0) {
        return consulta;
      }

      const limitador = this.limit;
      let formatado = "";
      let limit = "";

      switch (bancoId) {
        case "FIR": // Firebird
          limit = `FIRST ${limitador}`;
          formatado = `SELECT ${limit} * FROM ( ${consulta} ) res`;
          break;

        case "SAP": // MaxDB/SAPDB
          limit = `AND ROWNO <= ${limitador}`;
          formatado = `SELECT * FROM ( ${consulta} ) res WHERE (1=1 ${limit})`;
          break;

        case "MSS": // SQL Server
        case "IRIS": // Intersystems IRIS
          limit = `TOP ${limitador}`;
          formatado = `SELECT ${limit} * FROM ( ${consulta} ) res`;
          break;

        case "ORA": // Oracle
          limit = `AND ROWNUM <= ${limitador}`;
          formatado = `SELECT * FROM ( ${consulta} ) res WHERE (1=1 ${limit})`;
          break;

        case "MYS": // MySQL
          limit = `LIMIT ${limitador}`;
          formatado = `SELECT * FROM ( ${consulta} ) res ${limit}`;
          break;

        case "POS": // PostgreSQL
          limit = `LIMIT ${limitador}`;
          formatado = `SELECT * FROM ( ${consulta} ) res ${limit}`;
          break;

        case "API_G": // API Genérica
          limit = `LIMIT ${limitador}`;
          formatado = `SELECT ${limit} * FROM ( ${consulta} ) res`;
          break;

        default:
          formatado = consulta;
      }

      return formatado;
    },
    resizeend(e1, e2) {
      console.log("Resize ended", e1, e2);
    },
    async carregarConfigDB(node) {
      this.loadingTree = true;
      if (node.type == "start") {
        await this.carregarDB(node);
      }
      if (node.type == "database") {
        await this.carregarEsquemas(node);
      }
      if (node.type == "schema") {
        await this.carregarTabelas(node);
      }
      if (node.type == "table") {
        await this.carregarColunas(node);
      }
      this.loadingTree = false;
    },
    async carregarDB(node) {
      const q = this.sistemaLicenciadaItem.bat_sql_bancos;
      const resultado = await this.consultaQuery(q, node);
      const array = !resultado
        ? []
        : resultado.map((item) => {
            return {
              name: item.banco_de_dados,
              icon: "mdi-database",
              children: [],
              type: "database"
            };
          });
      this.treeData = array;
    },
    async carregarEsquemas(node) {
      let q = this.sistemaLicenciadaItem.bat_sql_esquemas;
      if (!q) {
        node.type = "schema";
        node.data = {
          banco: node.name
        };
        return;
      }
      q = q.replace("{banco}", node.name);
      const resultado = await this.consultaQuery(q, node);
      const array = !resultado
        ? []
        : resultado.map((item) => {
            return {
              name: item.esquema,
              icon: "mdi-folder-outline",
              children: [],
              type: "schema",
              data: {
                banco: node.name
              }
            };
          });
      node.children = array;
    },
    async carregarTabelas(node) {
      let q = this.sistemaLicenciadaItem.bat_sql_tabelas;
      q = q.replace("{banco}", node.data?.banco);
      q = q.replace("{esquema}", node.name);
      const resultado = await this.consultaQuery(q, node);
      const array = !resultado
        ? []
        : resultado.map((item) => {
            return {
              name: item.nome_da_tabela,
              icon: "mdi-table",
              children: [],
              type: "table",
              data: {
                banco: node.data?.banco,
                esquema: node.name,
                item: item
              }
            };
          });
      node.children = array;
    },
    async carregarColunas(node) {
      let q = this.sistemaLicenciadaItem.bat_sql_colunas;
      q = q.replace("{banco}", node.data?.banco);
      q = q.replace("{esquema}", node.data?.esquema);
      q = q.replace("{tabela}", node.name);
      const resultado = await this.consultaQuery(q, node);
      const array =
        resultado.length > 0
          ? resultado.map((item) => {
              return {
                name: `${item.nome_da_coluna} (${item.tipo_de_dado})`,
                icon: "mdi-tag-outline",
                type: "column"
              };
            })
          : [
              {
                name: "Nenhuma coluna encontrada",
                icon: "mdi-alert",
                type: "column"
              }
            ];
      node.children = array;
    },
    async consultaQuery(q, node) {
      if (!q) return null;
      try {
        const responseExec = await sqlRunnerService.execQuery(
          this.sistemaLicenciadaSelecionado,
          q,
          { showOverlay: false }
        );

        if (!responseExec.data.sucesso) {
          this.error = responseExec.data.error;
          return null;
        }

        const uid = responseExec.data.uid;

        const responseResposta = await sqlRunnerService.respostaQuery(
          this.sistemaLicenciadaSelecionado,
          uid,
          { showOverlay: false }
        );

        const requisicaoData = responseResposta.data.requisicao;

        if (!requisicaoData.sucesso) {
          this.error = requisicaoData.error;
          return null;
        }
        if (requisicaoData.requisicao.status == "PENDENTE") {
          this.nodePendente = node;
          this.error =
            "A consulta ainda está sendo processada. Por favor, aguarde alguns instantes e tente novamente.";
          return null;
        }
        if (requisicaoData.requisicao.sucesso_requisicao) {
          this.nodePendente = null;
          return requisicaoData.requisicao.resultado;
        } else {
          this.error = requisicaoData.requisicao.resultado;
        }
      } catch (error) {
        this.error = error.response
          ? error.response.data.requisicao.requisicao.resultado
          : "Erro ao executar a query.";
      } finally {
        this.queryLoadingResposta = false;
      }
      this.nodePendente = null;
      return null;
    },
    resetTreeData() {
      this.treeData = [
        {
          name: "Carregar estrutura de dados",
          children: [],
          type: "start"
        }
      ];
    },
    copyColumnName(columnName) {
      this.copiarAreaTransferencia(columnName);
    }
  }
};
</script>

<style>
.sql-item {
  max-width: 400px; /* ajuste o valor conforme necessário */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.fa-eye {
  cursor: pointer;
  transition: all 0.3s ease; /* Aplica a transição para todas as propriedades */
}

.fa-eye:hover {
  color: #007bff; /* Muda a cor */
  transform: scale(1.1); /* Aumenta o tamanho */
}

.pui-datatable thead th:nth-child(1),
.pui-datatable tbody td:nth-child(1),
.pui-datatable tfoot td:nth-child(1) {
  width: 45px;
  max-width: 45px;
}

.p-datatable .p-frozen-column {
  background: #ffffff;
}
</style>
